import { CollectibleScreen } from 'app/features/collectible/screen'
import { makeQuery } from 'app/hooks/use-query'
import { createCollectiblePageQuery } from 'app/queries/collectibles/single'
import { dehydrate, QueryClient } from 'react-query'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import { withAuthedPage } from '../../lib/session'
import { verifyUser } from 'lib/verify-user'

export default CollectibleScreen

export function CollectiblePageScreen({
  slug,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return <CollectibleScreen slug={slug} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async (context) => {
    const store = context.req?.userStore
    const redirect = verifyUser(store)
    if (redirect) return redirect

    const { slug } = context.params as { slug: string }

    const queryClient = new QueryClient()
    const { query, mapToPage } = createCollectiblePageQuery()
    const variables = { slug }

    const res = await makeQuery(query, variables, mapToPage)

    const fetched = await queryClient.fetchQuery(
      ['query', query, variables],
      async () => {
        return res
      },
    )

    const dehydratedState = dehydrate(queryClient)

    return {
      props: {
        slug,
        dehydratedState,
      },
      notFound: !fetched?.hasContent,
    }
  },
)
